import * as React from "react";
import Popover from "@mui/material/Popover";
import { makeStyles } from "@material-ui/core/styles";
import {Close,ArrowDropUp,ArrowDropDown} from '@material-ui/icons'
import Slider from '@mui/material/Slider';
import { Grid, Typography } from "@material-ui/core";



function valuetext(value) {
    return `${value} Hrs`;
  }
  
function FlyDuration(props) {

  const [anchorEl, setAnchorEl] = React.useState(null);


  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleUpdate=(e)=>{
    handleChange(e.target.value)    
  }

  const handleChange=(val)=>{
    if(props.onChange)
    props.onChange(val)
  }
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

 const handleClear=(e)=>{
   e.stopPropagation()
   handleChange(props.defaultValue)
   handleReset()
 }
 const handleReset=()=>
 {
  if(props.onReset)
  props.onReset();
 }

  return (
    <div>
         {/* <Typography style={{fontSize:'14px',textAlign:'left',marginBottom:'5px',marginLeft:'5px'}}>Duration</Typography> */}
      <div className='filter-button' onClick={handleClick}>
     
      <Typography component="span" className="filter-text">{props.used? valuetext(props.value):"Duration"}</Typography>
        <Typography variant="span" className="filter-arrow">
            {open?<ArrowDropUp/>:<ArrowDropDown/>}
        </Typography>
     {props.used?   <Typography className="icon-close" variant="a" style={{fontSize:'12px'}} onClick={handleClear}><Close/></Typography>:""}
      </div>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        
        <div style={{width:'350px',padding:'30px 25px',backgroundColor:'var(--backgroundcolor)',borderRadius:'5px'}}>
            <Grid container>
                <Grid item xs="10">
      <Typography component="span" style={{color:'var(--darker)'}}>Select Max Fly Duration</Typography></Grid>
      <Grid item xs="2"> <Typography component="span"  style={{color:'var(--darker)'}}>{props.value} Hrs</Typography></Grid>
      </Grid>
      <Slider
        aria-label="Max Fly Duration"
        defaultValue={1}
        getAriaValueText={valuetext}        
         value={props.value}
         step={1}
        // marks
        min={1}
        max={100}
        valueLabelDisplay="auto"
         onChange={handleUpdate}
        //  onChangeCommitted={val=>console.log('Commited',val)}
      />
    </div>
      
      </Popover>
    </div>
  );
}

export default React.memo(FlyDuration);

FlyDuration.defaultProps={
  value:1
}
